import { useMutation, useQueryClient } from 'react-query';
import Notiflix from 'notiflix';
import axios from 'axios';

const updateProjectName = async info => {
  const { id, data } = info;
  const res = await axios.patch(`/app/bb_datasheep_projects/${id}`, data);
  return res.data;
};

export const useRenameProjectMutation = () => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: updateProjectName,
    onMutate: async ({ id, data }) => {
      await queryClient.cancelQueries(['ALL_PROJECTS']);
      const previousProject = queryClient.getQueryData(['ALL_PROJECTS']);
      queryClient.setQueryData(['ALL_PROJECTS'], oldProjects =>
        oldProjects.map(project => (project._id === id ? { ...project, ...data } : project))
      );
      return { previousProject };
    },
    onError: (error, id, context) => {
      queryClient.setQueryData(['ALL_PROJECTS'], context.previousProjects);
      Notiflix.Notify.failure(error.message);
    },
    onSuccess: async () => {
      queryClient.invalidateQueries(['ALL_PROJECTS']);
    }
  });

  return { mutate };
};
